import Env from '../util.env'; // 公众号APPID

var WX_APPID_TEST = 'wxf18a88f56d23da94';
var WX_APPID_ECS = 'wxf18a88f56d23da94';
var WX_APPID_ONLINE = 'wxf18a88f56d23da94'; // 嘀嗒出行官方号

var WX_APPID = WX_APPID_ONLINE;

if (Env.isEnvECS) {
  WX_APPID = WX_APPID_ECS;
} else if (Env.isEnvTest) {
  WX_APPID = WX_APPID_TEST;
}

export { WX_APPID };